import {param, typedQuery} from "../../typing";
import externalApi from "../../../api/external";
import {AccountMin, DataRoomId, ThirdPartyId, TprmExternalQuestionnaireId} from "../../../Types";
import {HTTPError} from "../../../api";

export const externalQuestionnaire = typedQuery(
  [
    "external",
    "portal",
    "externalQuestionnaire",
    param<AccountMin>("account"),
    param<ThirdPartyId>("thirdPartyId"),
    param<TprmExternalQuestionnaireId>("externalQuestionnaireId"),
  ],
  async (account, thirdPartyId, externalQuestionnaireId) => {
    return await externalApi.portal.getExternalQuestionnaire(account, thirdPartyId, externalQuestionnaireId);
  },
);

export const externalQuestionnaireAccessible = typedQuery(
  [
    "external",
    "portal",
    "externalQuestionnaireAccessible",
    param<AccountMin>("account"),
    param<ThirdPartyId>("thirdPartyId"),
    param<TprmExternalQuestionnaireId>("externalQuestionnaireId"),
  ],
  async (account, thirdPartyId, externalQuestionnaireId) => {
    try {
      await externalApi.portal.getExternalQuestionnaire(account, thirdPartyId, externalQuestionnaireId);
      return true;
    } catch (ex) {
      if (ex instanceof HTTPError && ex.response.status === 401) {
        return false;
      }
      throw ex;
    }
  },
);

export const template = typedQuery(
  [
    "external",
    "portal",
    "externalQuestionnaire",
    "template",
    param<AccountMin>("account"),
    param<ThirdPartyId>("thirdPartyId"),
    param<TprmExternalQuestionnaireId>("externalQuestionnaireId"),
  ],
  async (account, thirdPartyId, externalQuestionnaireId) => {
    return await externalApi.portal.getExternalQuestionnaireTemplate(account, thirdPartyId, externalQuestionnaireId);
  },
);

export const dataRooms = typedQuery(
  ["external", "portal", "dataRooms", param<AccountMin>("account"), param<ThirdPartyId>("thirdPartyId")],
  async (account, thirdPartyId) => {
    return await externalApi.portal.listDataRooms(account, thirdPartyId);
  },
);

export const externalQuestionnaires = typedQuery(
  ["external", "portal", "externalQuestionnaires", param<AccountMin>("account"), param<DataRoomId>("dataRoomId")],
  async (account, dataRoomId) => {
    return await externalApi.portal.listExternalQuestionnaires(account, dataRoomId);
  },
);

export const portalUsers = typedQuery(
  ["external", "portal", "portal", "portal_users", param<AccountMin>("account"), param<ThirdPartyId>("thirdPartyId")],
  async (account, thirdPartyId) => {
    return await externalApi.portal.listPortalUsers(account, thirdPartyId);
  },
);

export const portal = typedQuery(
  ["external", "portal", "third_party", param<AccountMin>("account"), param<ThirdPartyId>("thirdPartyId")],
  async (account, thirdPartyId) => {
    return await externalApi.portal.getPortal(account, thirdPartyId);
  },
);

export const hasPermission = typedQuery(
  ["external", "portal", "has_permission", param<AccountMin>("account"), param<ThirdPartyId>("thirdPartyId")],
  async (account, thirdPartyId) => {
    try {
      const portal = await externalApi.portal.getPortal(account, thirdPartyId);
      return {hasPermission: true, portal};
    } catch (ex) {
      if (ex instanceof HTTPError && ex.response.status === 403) {
        return {hasPermission: false};
      }
      throw ex;
    }
  },
);
